import { render, staticRenderFns } from "./LoginBase.vue?vue&type=template&id=6f2aeb1e&scoped=true&"
import script from "./LoginBase.vue?vue&type=script&lang=js&"
export * from "./LoginBase.vue?vue&type=script&lang=js&"
import style0 from "./LoginBase.vue?vue&type=style&index=0&id=6f2aeb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2aeb1e",
  null
  
)

export default component.exports